import React from 'react';
import { formatMoney, formatDateTime, rowBadges, alertSummary } from '../utils/competitorSeries';

// La lista del panel: una fila por producto nuestro enganchado al comparador. La diferencia es
// contra la MEDIANA de las tiendas que hoy tienen stock — en rojo cuando estamos por encima,
// en verde cuando por debajo. Tocar una fila abre el detalle.
const TableCompetitorPricesComponent = ({ rows, onOpen }) => {
    if (!rows || rows.length === 0) {
        return (
            <div className="card card-small mb-4">
                <div className="card-body text-muted" style={{ textAlign: 'center' }}>No hay productos en este filtro.</div>
            </div>
        );
    }

    return (
        <div className="card card-small mb-4">
            <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                <table className="table table-hover mb-0">
                    <thead className="bg-light">
                        <tr>
                            <th scope="col" className="border-0">Producto</th>
                            <th scope="col" className="border-0" style={{ textAlign: 'right' }}>Nuestro</th>
                            <th scope="col" className="border-0" style={{ textAlign: 'right' }}>Mediana</th>
                            <th scope="col" className="border-0" style={{ textAlign: 'right' }}>Mínimo</th>
                            <th scope="col" className="border-0" style={{ textAlign: 'center' }} title="Tiendas que hoy lo tienen con stock">Tiendas</th>
                            <th scope="col" className="border-0" style={{ textAlign: 'right' }}>Diferencia</th>
                            <th scope="col" className="border-0" style={{ textAlign: 'right' }}>Último cambio</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row) => (
                            <tr
                                key={`${row.prefix}-${row.code}`}
                                data-code={row.code}
                                style={{ cursor: 'pointer' }}
                                onClick={() => onOpen && onOpen(row)}
                            >
                                <td>
                                    {row.name}
                                    <div style={{ fontSize: '11px' }}>
                                        {rowBadges(row).map((badge) => (
                                            <span key={badge.text} className={`badge badge-${badge.kind}`} style={{ marginRight: '6px' }}>
                                                {badge.text}
                                            </span>
                                        ))}
                                    </div>
                                    {/* Por qué está marcado: qué tienda cambió qué. */}
                                    {alertSummary(row) && (
                                        <div className="text-danger" style={{ fontSize: '12px', marginTop: '2px' }}>{alertSummary(row)}</div>
                                    )}
                                </td>
                                <td style={{ textAlign: 'right' }}>
                                    {formatMoney(row.ownPrice)}
                                    {!row.ownStock && <div style={{ fontSize: '11px' }} className="text-muted">sin stock</div>}
                                </td>
                                <td style={{ textAlign: 'right' }}>{formatMoney(row.median)}</td>
                                <td style={{ textAlign: 'right' }}>{formatMoney(row.min)}</td>
                                <td style={{ textAlign: 'center' }}>{row.storesInStock}</td>
                                <td style={{ textAlign: 'right' }}>
                                    {row.diffPct == null ? '—' : (
                                        <strong className={row.diffPct > 0 ? 'text-danger' : (row.diffPct < 0 ? 'text-success' : '')}>
                                            {row.diffPct > 0 ? '+' : ''}{String(row.diffPct).replace('.', ',')}%
                                        </strong>
                                    )}
                                </td>
                                <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }} className="text-muted">
                                    {row.lastChangeAt ? formatDateTime(row.lastChangeAt) : '—'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TableCompetitorPricesComponent;
